<div class="flex flex-row justify-between pb-3 pr-2 relative items-center">
  <div class="flex flex-row items-center">
    <h2
      mat-dialog-title
      class="!pl-0 text-2xl !m-0 font-bold !text-blue-theme-color"
    >
      {{ this.heading }}
    </h2>
  </div>
  <button
    mat-icon-button
    class="dialog-close-btn flex items-center justify-center"
    mat-dialog-close
  >
    <mat-icon class="text-blue-theme-color text-xl">close</mat-icon>
  </button>
</div>
<mat-dialog-content class="mt-16 pt-4 !py-0">
  <div class="w-full">
    <p class="text-center">
      Empower your business with our bulk delivery solution for effortless
      package distribution and seamless payment collection. Optimize your
      business operations now!
    </p>
  </div>
  <div class="mt-4">
    <form [formGroup]="this.form">
      <div
        class="flex flex-col"
      >
        <label class="label font-medium">Business Name</label>
        <mat-form-field class="flex-1 form-field" appearance="fill">
          <input formControlName="busniessName" matInput class="mt-1" />
          <mat-error>Business name is required</mat-error>
        </mat-form-field>
      </div>
      <div class="row">
        <label class="label font-medium">Select Business Sector</label>
        <mat-form-field class="w-full form-field" appearance="fill">
          <mat-select
            formControlName="busniessSector"
            class="!flex !items-center"
          >
            <mat-option
              *ngFor="let item of this.sectorList"
              [value]="item.value"
              >{{ item.label }}</mat-option
            >
          </mat-select>
          <mat-error>Business sector is required</mat-error>
        </mat-form-field>
      </div>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions
  *ngIf="_data?.type != 'html'"
  class="mt-2 !pb-5 !px-0 justify-center"
>
  <button
    color="primary"
    [disabled]="this.form.pending"
    (click)="onSubmit()"
    class="!bg-blue-theme-color md:!w-[130px] sm:!w-full !w-full !h-11 text-white-color"
    mat-flat-button
  >
    <span *ngIf="!this.form.pending">Start</span>
    <mat-progress-spinner
      class="custom-spinner !text-white-color"
      *ngIf="this.form.pending"
      [diameter]="24"
      [mode]="'indeterminate'"
    ></mat-progress-spinner>
  </button>
</mat-dialog-actions>
